import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BTBusRequest } from "../../shared/BTBusRequest";
import { DataService_BusTrackerBusMaintenance } from "../../shared/data.service";

@Component({
	selector: "app-bus-modify",
	templateUrl: "./bus-modify.component.html",
	styleUrls: ["./bus-modify.component.css"],
})
export class BusModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private busService: DataService_BusTrackerBusMaintenance
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;
		this.Imported = this.dialogConfig.data.Imported;
		this.user = this.dialogConfig.data.user;

		if (this.EditMode == true) {
			this.BusID = this.dialogConfig.data.BusID;
			this.BusNbr = this.dialogConfig.data.BusNbr;
			this.BusDesc = this.dialogConfig.data.BusDesc;
			this.DefinedByID = this.dialogConfig.data.DefinedByID;
		}
	}

	//////////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////////

	user: any;
	EditMode: any = false;
	Imported: any = false;
	BusID: any = -1;
	BusNbr: any = "";
	BusDesc: any = "";
	DefinedByID: any = 4;

	errorMessage: any = "";

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.BusNbr == "") {
			this.errorMessage = "Enter a Bus Number";
			return;
		}
		if (this.BusDesc == "") {
			this.errorMessage = "Enter a Bus Name/Description";
			return;
		}

		if (this.BusNbr.length > 20) {
			this.errorMessage = "Bus Number must be <= 20 characters";
			return;
		}
		if (this.BusDesc.length > 100) {
			this.errorMessage = "Bus Description must be <= 100 characters";
			return;
		}

		//
		// Create Request
		//
		let parms: BTBusRequest = {
			BusID: -1,
			BusNbr: this.BusNbr,
			BusDesc: this.BusDesc,
			DefinedByID: 4, //this.user.UserLevelID == 3 ? 3 : 4
		};

		//
		// Call SP
		//
		var result = this.busService.BusInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Bus was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the bus",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		if (this.BusNbr == "") {
			this.errorMessage = "Enter a Bus Number";
			return;
		}
		if (this.BusDesc == "") {
			this.errorMessage = "Enter a Bus Name/Description";
			return;
		}

		if (this.BusNbr.length > 20 && this.Imported == false) {
			this.errorMessage = "Bus Number must be <= 20 characters";
			return;
		}
		if (this.BusDesc.length > 100) {
			this.errorMessage = "Bus Description must be <= 100 characters";
			return;
		}

		//
		// Create Request
		//
		let parms: BTBusRequest = {
			BusID: this.BusID,
			BusNbr: this.BusNbr,
			BusDesc: this.BusDesc,
			DefinedByID: this.DefinedByID,
		};

		//
		// Call SP
		//
		var result = this.busService.BusUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Bus was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Bus",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////////////////////
}
